var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import { styled } from '@web/theme';
import { useFirebase } from '@web/firebase';
export var FirebaseUI = function (_a) {
    var redirectUrl = _a.redirectUrl;
    var _b = useFirebase(), instance = _b.instance, uiConfig = _b.uiConfig, firebase = _b.firebase;
    var _c = useState(false), shown = _c[0], setShownState = _c[1];
    useEffect(function () {
        if (instance && uiConfig) {
            if (firebase.apps.length > 0) {
                instance.ui.start('#firebaseui-auth-container', __assign({}, uiConfig));
                setShownState(true);
            }
        }
    }, [instance, uiConfig, shown, redirectUrl]);
    return (React.createElement(Panel, null,
        React.createElement("div", null,
            React.createElement("div", { id: "firebaseui-auth-container" }))));
};
var Panel = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: .2rem;\n  width: 280px;\n  font-size: 12px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: .2rem;\n  width: 280px;\n  font-size: 12px;\n"])));
var templateObject_1;
